export abstract class Storage {
	public abstract get<Data = any>(key?: string): Promise<Data>;
	public abstract set(data: Record<string, any>): void;
	public abstract remove(key: string): void;
}
